const MIME_TYPES = {
  document: "doc,docx,xls,xlsx,ppt,pptx,pdf,txt",
  image: "png,jpg,gif,jpeg,bmp",
  video: "flv,mp4,avi,wmv,rm,rmvb,mpeg,mpg,mov,mkv",
  audio: "mp3,wav,wma",
  zip: "zip,rar",
  flash: "swf",
  srt: "srt"
}
export {
  MIME_TYPES
}